export default (name = '', max: number, suffix = ''): string => {
  // Get the shorter name - the shorter name is the name broken at the last space in the
  // first 50 characters
  const endPosition = name.substring(0, max).lastIndexOf(' ');
  return name.length > max ? name.substring(0, endPosition) + suffix : name;
};
